var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('div',{staticClass:"flex flex-col justify-center items-center h-full mt-5 w-full"},[_c('el-loading',{attrs:{"text":'Loading...'}})],1):_c('div',[_c('div',{staticClass:"p-2"},[_c('ve-table',{attrs:{"columns":_vm.columns,"table-data":_vm.feedback}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }